<div class="page-container">
  <div class="page-header-container listing-page-header-container">
    <sxw-bread-crumb [items]="breadCrumb" class="mb-20" />
    <app-page-header
      [showSubmit]="false"
      [title]="'STOCK_TYPE.TITLES.STOCK_TYPE'"
      [showCreateButton]="true"
      [createBtnPermission]="createPermission" />
  </div>
  <div class="page-content-container listing-page-content-container">
    <app-section theme="p-0">
      <app-list [filterConfig]="filterConfig" [listingConfig]="tableConfig" [searchConfig]="searchConfig"></app-list>
    </app-section>
  </div>
</div>
